import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';

const AdminRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAdminAuthentication();
  }, []);

  const checkAdminAuthentication = async () => {
    try {
      // Vérifier le localStorage d'abord
      const user = JSON.parse(localStorage.getItem('user') || 'null');
      
      if (!user || user.role !== 'admin') {
        console.log('🚫 Accès refusé: Utilisateur non admin');
        setIsAuthenticated(false);
        setLoading(false);
        return;
      }

      // Vérifier avec le serveur
      const response = await fetch('https://d4unaturally.com/api/check-admin.php', {
        method: 'GET',
        credentials: 'include'
      });

      if (response.ok) {
        const data = await response.json();
        if (data.success && data.user.role === 'admin') {
          console.log('✅ Accès admin autorisé');
          setIsAuthenticated(true);
        } else {
          console.log('🚫 Session admin invalide');
          localStorage.removeItem('user');
          setIsAuthenticated(false);
        }
      } else {
        console.log('🚫 Erreur vérification admin');
        localStorage.removeItem('user');
        setIsAuthenticated(false);
      }
    } catch (error) {
      console.error('💥 Erreur vérification admin:', error);
      localStorage.removeItem('user');
      setIsAuthenticated(false);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <div className="text-lg text-gray-700">Vérification des droits d'accès...</div>
          <div className="text-sm text-gray-500 mt-2">Veuillez patienter</div>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    console.log('🔒 Redirection vers la page de login');
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};

export default AdminRoute;